import { SectionHeader } from "@/theme1/components/common/SectionHeader";

export default function ProductFeatures({ features }) {
  // Safety check - if features is an array of specifications objects
  const renderFeatures = () => {
    if (!features) return null;

    // If features is an array of specification objects with label/value
    if (Array.isArray(features) && features.length > 0 && features[0].label) {
      return (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((item, index) => (
            <div key={index} className="rounded-2xl bg-neutral-100/35 p-5 text-center">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
                {item.label}
              </p>
              <p className="mt-2 font-medium">{item.value}</p>
            </div>
          ))}
        </div>
      );
    }

    // If features is an array of strings
    if (Array.isArray(features) && typeof features[0] === 'string') {
      return (
        <ul className="grid gap-3 sm:grid-cols-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <span className="mt-1 flex size-4 shrink-0 rounded-full bg-black text-white items-center justify-center text-[8px] font-bold">
                ✓
              </span>
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      );
    }

    return null;
  };

  return (
    <section className="rounded-[2rem] border border-border/60 p-6 shadow-xl shadow-black/5 md:p-8 lg:p-10">
      <SectionHeader
        eyebrow="Features"
        title="Why you'll love it."
        description="Every detail is crafted with intention, from fit to finish."
      />
      <div className="mt-8">{renderFeatures()}</div>
    </section>
  );
}
